module.exports = __webpack_public_path__ + "img/vn.740ee4d2.svg";